import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const isPreview = () => new URLSearchParams(window.location.search).get("preview") === "1";

export function useSite(path = "/public/site") {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = isPreview() ? await api.get("/admin/preview").catch(() => api.get(path)) : await api.get(path);
        if (alive) setData(res.data);
      } catch (e) {
        if (alive) setError(e);
      }
    };
    load();
    return () => {
      alive = false;
    };
  }, [path]);
  return { data, error };
}
